<template>
  <div>
    <p v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-1')" />
    <br />
    <ul style="list-style-type: square; margin-left: 25px">
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-2')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-3')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-4')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-5')"></li>
      <li>
        <span
          v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-14')"
        /><a class="link" @click="$emit('displayISO')">
          {{ $t('compCarbonFormsTravelsFormatsGeslabHelp.link') }}</a
        >
        ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-6')"></li>
      <li>
        <span
          v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-15')"
        /><a class="link" @click="$emit('displayISO')">
          {{ $t('compCarbonFormsTravelsFormatsGeslabHelp.link') }}</a
        >
        ;
      </li>
      <li>
        <span v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-7')" />
        {{ TRANSPORTATIONS.map((value) => $t(value)) }}.
        <span v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-8')" />
        {{ $t(TRANSPORTATIONS[0]) }} > {{ $t(TRANSPORTATIONS[1]) }} >
        {{ $t(TRANSPORTATIONS[8]) }} > {{ $t(TRANSPORTATIONS[4]) }} >
        {{ $t(TRANSPORTATIONS[2]) }} > {{ $t(TRANSPORTATIONS[6]) }} >
        {{ $t(TRANSPORTATIONS[7]) }} > {{ $t(TRANSPORTATIONS[3]) }} >
        {{ $t(TRANSPORTATIONS[5]) }} ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-9')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-10')"></li>
      <li>
        <span v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-11')" />
        <a class="link" @click="$emit('displayPurposeMapping')">
          {{ $t('compCarbonFormsTravelsFormatsGeslabHelp.link-purpose') }}</a
        >
        ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-12')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsGeslabHelp.info-13')"></li>
    </ul>
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import { useCoreStore } from '@/stores/core'

export default {
  name: 'Help',
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    TRANSPORTATIONS: function () {
      return Travel.transportations
    }
  }
}
</script>
